import { t } from "i18next"
export const bookingPlatformsTransformer = response => {
  if (!response?.length) return []

  const updatedResponse =
    response?.length >= 1 ? [{ id: -1, title: t("Propforce"), key: "propforce" }, ...response] : response

  return updatedResponse.map(item => ({
    ...item,
    value: item,
    label: item?.title,
  }))
}
